module.exports = __webpack_public_path__ + "img/webright_top.024530a5.png";